import httpClient from './api/httpClient';

const END_POINT = 'chamada';
export const getAll = () => httpClient.get(END_POINT + '/all');
export const getAllByProcessoSeletivo = (idProcessoSeletivo) => httpClient.get(END_POINT + '/getAllByProcessoSeletivo/'+ idProcessoSeletivo);

export const create = (chamada) => {
    let formData = new FormData();
    formData.append('titulo', chamada.titulo);
    formData.append('sigla', chamada.sigla);
    formData.append('ordemExibicao', chamada.ordemExibicao);
    formData.append('idProcessoSeletivo', chamada.idProcessoSeletivo);
    formData.append('inscricaoInicio', dataString(chamada.inscricaoInicio));
    formData.append('inscricaoFim', dataString(chamada.inscricaoFim));
    formData.append('utilizaCadunico', chamada.utilizaCadunico === false ? 'false' : 'true');
    formData.append('arquivo', chamada.arquivo);

    return httpClient.post(END_POINT, formData);
}

export const enviarEmails = (chamada) => httpClient.get(END_POINT + '/' + chamada.id + '/enviar-emails');

const dataString = (datetime) => {
    return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000)).toISOString();
 }
